// extracted by mini-css-extract-plugin
export default {"container":"CustomCard_container__a0dO8","title":"CustomCard_title__oUDqQ"};